import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";

import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/public/Home";
import Menu from "@/pages/public/Menu";
import Historia from "@/pages/public/Historia";
import Galeria from "@/pages/public/Galeria";
import Ubicacion from "@/pages/public/Ubicacion";

import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Mesero from "@/pages/admin/Mesero";
import Taquero from "@/pages/admin/Taquero";
import Caja from "@/pages/admin/Caja";
import RootDashboard from "@/pages/admin/Root";
import Users from "@/pages/admin/Users";
import Products from "@/pages/admin/Products";
import ProtectedRoute from "@/components/admin/ProtectedRoute";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route index element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/historia" element={<Historia />} />
            <Route path="/galeria" element={<Galeria />} />
            <Route path="/ubicacion" element={<Ubicacion />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/admin/login" replace />} />
            <Route path="root" element={<ProtectedRoute roles={["root"]}><RootDashboard /></ProtectedRoute>} />
            <Route path="users" element={<ProtectedRoute roles={["root"]}><Users /></ProtectedRoute>} />
            <Route path="products" element={<ProtectedRoute roles={["root"]}><Products /></ProtectedRoute>} />
            <Route path="mesero" element={<ProtectedRoute roles={["mesero", "root"]}><Mesero /></ProtectedRoute>} />
            <Route path="caja" element={<ProtectedRoute roles={["caja", "root"]}><Caja /></ProtectedRoute>} />
            <Route path="taquero" element={<ProtectedRoute roles={["taquero1", "taquero2", "taquero3", "root"]}><Taquero /></ProtectedRoute>} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
